import { useRoute, useRouter } from 'vue-router'

export function useCart() {
  const router = useRouter();
  const route = useRoute();

  function openCart() {
    // console.log('openCart');
    router.push({ query: { ...route.query, cart: null } })
  }

  function closeCart() {
    // console.log('closeCart');
    router.push({ query: { ...route.query, cart: undefined } })
  }

  function toggleCart() {
    if (Object.keys(route.query).includes('cart')) {
      closeCart()
    } else {
      openCart()
    }
  }

  function isCartOpen() {
    return Object.keys(route.query).includes('cart');
  }

  return { openCart, closeCart, toggleCart, isCartOpen }
}
